import { enhanceOptionsSchemaWithDynamicOptions } from '../utils';

export const ellipseOptionsSchema = enhanceOptionsSchemaWithDynamicOptions({
    fillColor: {
        default: '> themes.defaultFillColor',
        description:
            'Specify the fill color. You may use a dataSource to apply the color. The hex value format should be "#FFFFFF". The default for enterprise light is "#C3CBD4". The default for enterprise dark is "#31373E". The default for prisma dark is "#0B0C0E".',
        type: 'string',
    },
    fillOpacity: {
        default: 1,
        description:
            'Specify the opacity of the fill. Choose a number in the range of 0 - 1 (inclusive). You can also express the value as a percentage. For example, "0.80" in source or "80%" in UI.',
        type: 'number',
    },
    strokeColor: {
        default: '> themes.defaultStrokeColor',
        description:
            'Specify the stroke color. You may use a dataSource to apply the color. The hex value format should be "#FFFFFF". The default for enterprise light is "#3C444D". The default for enterprise dark is "#C3CBD4". The default for prisma dark is "#ACACAD".',
        type: 'string',
    },
    strokeDashStyle: {
        default: 0,
        description:
            'Specify the size, in pixels, of dashes and spaces used to create a custom stitched outline. The value you specify applies to both the dashes and the spaces between them.',
        type: 'number',
    },
    strokeOpacity: {
        default: 1,
        description:
            'Specify the opacity of the stroke. Choose a number in the range of 0 - 1 (inclusive). You can also express the value as a percentage. For example, "0.80" in source or "80%" in UI.',
        type: 'number',
    },
    strokeWidth: {
        default: 1,
        description: 'Specify the width of the stroke, in pixels. The minimum value is 0.',
        type: 'number',
    },
});
